define.alias("shared/components/shared/profile-categorization/loading", "settings/components/shared/profile-categorization/loading");